import {
  UseMutationOptions,
  UseQueryResult,
  UseQueryOptions,
  useQuery,
  useMutation,
} from 'react-query';
import {
  ListMerchantCatalogsOrderByEnum,
  ListMerchantCatalogUploads200Response,
  MerchantCatalog,
  MerchantCatalogBase,
} from '../openapi';
import { CatalogClient } from '../clients/catalogs';
import { CatalogUploadClient } from '../clients/catalogUploads';

type CatalogParams = {
  merchantId?: string;
  catalogId?: string;
  orderBy?: ListMerchantCatalogsOrderByEnum;
  limit?: number;
};

export const useCatalogUploadQuery = (
  params: CatalogParams,
  options?: UseQueryOptions<
    unknown,
    unknown,
    ListMerchantCatalogUploads200Response
  >
): UseQueryResult<ListMerchantCatalogUploads200Response> =>
  useQuery({
    queryKey: ['catalogs-upload', params.merchantId, params.catalogId],
    queryFn: ({ pageParam }) =>
      params.merchantId &&
      params.catalogId &&
      CatalogUploadClient.listMerchantCatalogUploads(
        params.merchantId,
        params.catalogId,
        undefined,
        params.limit,
        pageParam
      ).then(({ data }) => data),
    ...options,
  });

export const useCatalogByIdQuery = (
  params: CatalogParams,
  options?: UseQueryOptions<unknown, unknown, MerchantCatalog>
): UseQueryResult<MerchantCatalog> =>
  useQuery({
    queryKey: ['catalog', params.catalogId],
    queryFn: () =>
      params.merchantId &&
      params.catalogId &&
      CatalogClient.getMerchantCatalog(
        params.merchantId,
        params.catalogId
      ).then(({ data }) => data),
    ...options,
  });

export const useCreateCatalog = (
  params: CatalogParams,
  options?: UseMutationOptions<MerchantCatalog, unknown, MerchantCatalogBase>
) =>
  useMutation({
    mutationFn: (newCatalog) =>
      CatalogClient.createMerchantCatalog(
        params.merchantId || '',
        newCatalog
      ).then(({ data }) => data),
    ...options,
  });

export const useUpdateCatalog = (
  params: CatalogParams,
  options?: UseMutationOptions<MerchantCatalog, unknown, MerchantCatalogBase>
) =>
  useMutation({
    mutationFn: (newCatalog) =>
      CatalogClient.updateMerchantCatalog(
        params.merchantId || '',
        params.catalogId || '',
        newCatalog
      ).then(({ data }) => data),
    ...options,
  });
